const CONTACT_PUBLIC_FIELDS = [
  "Nome",
  "NomeEmpresa",
  "Nif",
  "Telefone",
  "Telemovel",
  "Telemovel2",
  "Telemovel3",
  "CustoChamadaTelefone",
  "CustoChamadaTelemovel",
  "CustoChamadaTelemovel2",
  "CustoChamadaTelemovel3",
  "Email",
  "EmailNewsletter",
  "Whatsapp",
  "LinkMessenger",
  "LinkFacebook",
  "LinkYoutube",
  "LinkInstagram",
  "PDFInterCredito",
  "LinkInterCredito",
];

const pickPublicContact = (contact = {}) =>
  CONTACT_PUBLIC_FIELDS.reduce((safeContact, field) => {
    if (Object.prototype.hasOwnProperty.call(contact, field)) {
      safeContact[field] = contact[field];
    }
    return safeContact;
  }, {});

const pickPublicContacts = (contacts = []) =>
  Array.isArray(contacts) ? contacts.map(pickPublicContact) : [];

export { pickPublicContact, pickPublicContacts };
